
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  feedback: true,
  toc: true,
  subnav: true,
  maxTocLevel: 4,
  layout: 'reference',
  secondLevelToc: true,
  alwaysExpand: true,
  parentTocLevel: 3,
  childTocLevel: 4,
  description: 'API reference for endpoints and webhooks associated with the Plaid Assets product.',
  source: 'endpoint'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Callout = makeShortcode("Callout");
const Schema = makeShortcode("Schema");
const MDXCodeBlock = makeShortcode("MDXCodeBlock");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Assets' subtitle='API reference for Assets endpoints and webhooks' compact mdxType="Header" />
    <p>{`Create, delete, retrieve and share Asset Reports with information about a user's assets and transactions. For how-to guidance on Asset Reports, see the `}<a parentName="p" {...{
        "href": "/docs/assets/"
      }}>{`Assets documentation`}</a>{`.`}</p>
    <Callout mdxType="Callout">
      <p>{`All the endpoints on this page are also compatible with `}<a parentName="p" {...{
          "href": "/docs/assets/#financial-insights-reports-uk-only"
        }}>{`Financial Insights Reports (UK only)`}</a>{` and will automatically operate on Financial Insights Reports instead of Asset Reports if the Financial Insights Report add-on has been enabled. `}</p>
    </Callout>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Endpoints`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/asset_report/create`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Create an Asset Report`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/asset_report/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Get an Asset Report`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/asset_report/pdf/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Get a PDF Asset Report`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/asset_report/refresh`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Create an updated Asset Report`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/asset_report/filter`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Filter unneeded accounts from an Asset Report`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/asset_report/remove`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Delete an asset report`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/asset_report/audit_copy/create`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Create an Audit Copy of an Asset Report for sharing`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/asset_report/audit_copy/remove`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Delete an Audit Copy of an Asset Report`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/credit/relay/create`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Create a relay token of an Asset Report for sharing (beta)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/credit/relay/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve the report associated with a relay token (beta)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/credit/relay/refresh`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Refresh a report of a relay token (beta)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/credit/relay/remove`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Delete a relay token (beta)`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Webhooks`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#product_ready"
            }}><inlineCode parentName="a">{`PRODUCT_READY`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Asset Report generation has completed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#error"
            }}><inlineCode parentName="a">{`ERROR`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Asset Report generation has failed`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "endpoints"
    }}>{`Endpoints`}</h3>
    <h4 {...{
      "id": "asset_reportcreate"
    }}>{`/asset_report/create`}</h4>
    <Schema method='POST' route='/asset_report/create' type='request' mdxType="Schema">
      <MDXCodeBlock title='/asset_report/create' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`# access_tokens is a list of Item access tokens.
# Note that the assets product must be enabled for all Items.
# All fields on the options object are optional.
request = AssetReportCreateRequest(
    access_tokens=[access_token],
    days_requested=90,
    options=AssetReportCreateRequestOptions(
        webhook='https://www.example.com',
        client_report_id='123',
        user=AssetReportUser(
            client_user_id='7f57eb3d2a9j6480121fx361',
            first_name='Jane',
            middle_name='Leah',
            last_name='Doe',
            ssn='123-45-6789',
            phone_number='(555) 123-4567',
            email='jane.doe@example.com',
        )
    )
)
response = client.asset_report_create(request)
asset_report_id = response['asset_report_id']
asset_report_token = response['asset_report_token']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`# access_tokens is a list of Item access tokens.
# Note that the assets product must be enabled for all Items.
# All fields on the options Hash are optional.
options = {
  client_report_id: '123',
  webhook: 'https://www.example.com',
  user: {
    client_user_id: '7f57eb3d2a9j6480121fx361',
    first_name: 'Jane',
    middle_name: 'Leah',
    last_name: 'Doe',
    ssn: '123-45-6789',
    phone_number: '(555) 123-4567',
    email: 'jane.doe@example.com',
  },
}
request = Plaid::AssetReportCreateRequest.new(
  {
    access_tokens: [access_token],
    days_requested: 90,
    options: options
  }
)
response = client.asset_report_create(request)
asset_report_id = response.asset_report_id
asset_report_token = response.asset_report_token
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewAssetReportCreateRequest(90) // number of days requested
request.SetAccessTokens([]string{accessToken})
response, _, err := client.PlaidApi.AssetReportCreate(ctx).AssetReportCreateRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.AssetReportCreateRequest{DaysRequested: 90} // number of days requested

request.AccessTokens = []string{accessToken}
response, err := client.AssetReport.Create(ctx, request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/asset_report/create \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "access_tokens": [access_tokens],
  "days_requested": 90,
  "options": {
      "client_report_id": "123",
      "webhook": "https://www.example.com",
      "user": {
        "client_user_id": "userid123",
        "first_name": "Jane",
        "middle_name": "Leah",
        "last_name": "Doe",
        "ssn": "123-45-6789",
        "phone_number": "(555) 123-4567",
        "email": "jane.doe@example.com"
      }
  }
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`// access_tokens is an array of Item access tokens.
// Note that the assets product must be enabled for all Items.
// All fields on the options object are optional.
AssetReportCreateRequest assetReportCreateRequest = new AssetReportCreateRequest()
  .accessTokens(access_tokens)
  .daysRequested(90);
AssetReportUser assetReportUser = new AssetReportUser()
  .firstName("Alberta")
  .middleName("Bobbeth")
  .lastName("Charleson");
AssetReportCreateRequestOptions assetReportCreateOptions = new AssetReportCreateRequestOptions()
  .user(assetReportUser)
  .webhook(webhookUrl);
assetReportCreateRequest.options(assetReportCreateOptions);
Response<AssetReportCreateResponse> response = client
  .assetReportCreate(assetReportCreateRequest)
  .execute();
String assetReportId = response.body().getAssetReportId();
String assetReportToken = response.body().getAssetReportToken();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const daysRequested = 90;
const options = {
  client_report_id: '123',
  webhook: 'https://www.example.com',
  user: {
    client_user_id: '7f57eb3d2a9j6480121fx361',
    first_name: 'Jane',
    middle_name: 'Leah',
    last_name: 'Doe',
    ssn: '123-45-6789',
    phone_number: '(555) 123-4567',
    email: 'jane.doe@example.com',
  },
};
const request: AssetReportCreateRequest = {
  access_tokens: [accessToken],
  days_requested: daysRequested,
  options,
};
// accessTokens is an array of Item access tokens.
// Note that the assets product must be enabled for all Items.
// All fields on the options object are optional.
try {
  const response = await plaidClient.assetReportCreate(request);
  const assetReportId = response.data.asset_report_id;
  const assetReportToken = response.data.asset_report_token;
} catch (error) {
  // handle error
}
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/asset_report/create' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "asset_reportget"
    }}>{`/asset_report/get`}</h4>
    <Schema method='POST' route='/asset_report/get' type='request' mdxType="Schema">
      <MDXCodeBlock title='/asset_report/get' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewAssetReportGetRequest()
request.SetAssetReportToken(assetReportToken)
response, _, err := client.PlaidApi.AssetReportGet(ctx).AssetReportGetRequest(
  *request,
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.AssetReportGetRequest{}
request.AssetReportToken = &assetReportToken
response, err := client.AssetReport.Get(ctx, request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/asset_report/get \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "asset_report_token": String,
   "include_insights": Boolean
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`import json

# asset_report_token is the token from the AssetReport.create response.
try:
    request = AssetReportGetRequest(asset_report_token=asset_report_token)
    response = client.asset_report_get(request)
    report = response['report']
except plaid.ApiException as e:
   if json.loads(e.body)['error_code'] == 'PRODUCT_NOT_READY':
       # Asset report is not ready yet. Try again later.
       pass
   else:
       # Handle error.
       pass
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`// assetReportToken is the token from the AssetReportCreateRequest response.
AssetReportGetRequest request = new AssetReportGetRequest()
    .includeInsights(true)
    .assetReportToken(assetReportToken);
Response<AssetReportGetResponse> response =
    client().assetReportGet(request).execute();
if (response.isSuccessful()){
  AssetReport report = response.body().getReport();
} else {
  try{
    Gson gson = new Gson();
    PlaidError error = gson.fromJson(response.errorBody().string(), PlaidError.class);
    if (error.getErrorCode().equals("PRODUCT_NOT_READY")){
      // Asset report is not ready yet. Try again later
    }
  } catch (Exception e) {
    // handle error
  }
}

`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`# asset_report_token is the token from the AssetReport.create response.
begin
  request = Plaid::AssetReportGetRequest.new({ asset_report_token: asset_report_token })
  response = client.asset_report_get(request)
  report = response.report
rescue Plaid::ApiError => e
  json_response = JSON.parse(e.response_body)
  if json_response['error_code'] == 'PRODUCT_NOT_READY'
    # Asset report is not ready yet. Try again later
  end
  # handle error
end
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: AssetReportGetRequest = {
  asset_report_token: assetReportToken,
  include_insights: true,
};
try {
  const response = await plaidClient.assetReportGet(request);
  const report = response.data.report;
} catch (error) {
  if (error.response.data.error_code == 'PRODUCT_NOT_READY') {
    // Asset report is not ready yet. Try again later
  } else {
    // handle error
  }
}
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/asset_report/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "asset_reportpdfget"
    }}>{`/asset_report/pdf/get`}</h4>
    <Schema method='POST' route='/asset_report/pdf/get' type='request' mdxType="Schema">
      <MDXCodeBlock title='/asset_report/pdf/get' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`AssetReportPDFGetRequest assetReportPdfGet = new AssetReportPDFGetRequest()
  .assetReportToken(assetReportToken);
Response<ResponseBody> response = client()
  .assetReportPdfGet(assetReportPdfGet)
  .execute();
byte[] pdf = response.body().bytes();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`response, _, err := client.PlaidApi.AssetReportPdfGet(ctx).AssetReportPDFGetRequest(
  *plaid.NewAssetReportPDFGetRequest("ASSET_REPORT_TOKEN"),
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`response, err := client.AssetReport.GetPdf(ctx, &plaid.AssetReportPdfGetRequest{AssetReportToken: "ASSET_REPORT_TOKEN"})
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const request: AssetReportPDFGetRequest = {
    asset_report_token: assetReportToken,
  };
  const response = await plaidClient.assetReportPdfGet(request, {
    responseType: 'arraybuffer',
  });
  const pdf = response.data.toString('base64');
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = AssetReportPDFGetRequest(asset_report_token=asset_report_token)
pdf = client.asset_report_pdf_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::AssetReportPDFGetRequest.new({ asset_report_token: asset_report_token })
asset_report_pdf = client.asset_report_pdf_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/asset_report/pdf/get \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "asset_report_token": String
 }' \\
 -o 'asset_report.pdf'
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <h5 {...{
      "id": "response"
    }}>{`Response`}</h5>
    <p>{`This endpoint returns binary PDF data. `}<a parentName="p" {...{
        "href": "https://plaid.com/documents/sample-asset-report.pdf"
      }}>{`View a sample Asset Report PDF`}</a>{`. `}</p>
    <p><a parentName="p" {...{
        "href": "https://plaid.com/documents/sample-financial-insights-report.pdf"
      }}>{`View a sample Financial Insights Report (UK only) PDF`}</a>{`.`}</p>
    <h4 {...{
      "id": "asset_reportrefresh"
    }}>{`/asset_report/refresh`}</h4>
    <Schema method='POST' route='/asset_report/refresh' type='request' mdxType="Schema">
      <MDXCodeBlock title='/asset_report/refresh' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`options = {
    client_report_id: '123',
    webhook: 'https://www.example.com',
    user: {
      client_user_id: '7f57eb3d2a9j6480121fx361',
      first_name: 'Jane',
      middle_name: 'Leah',
      last_name: 'Doe',
      ssn: '123-45-6789',
      phone_number: '(555) 123-4567',
      email: 'jane.doe@example.com'
    }
}
request = Plaid::AssetReportRefreshRequest.new(
  {
    asset_report_token: asset_report_token,
    days_requested: 90,
    options: options
  }
)
response = client.asset_report_refresh(request)
asset_report_id = response.asset_report_id
asset_report_token = response.asset_report_token
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/asset_report/refresh \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "asset_report_token": "\${ASSET_REPORT_TOKEN}",
  "days_requested": 90,
  "options": {
      "client_report_id": "123",
      "webhook": "https://www.example.com",
      "user": {
        "client_user_id": "userid123",
        "first_name": "Jane",
        "middle_name": "Leah",
        "last_name": "Doe",
        "ssn": "123-45-6789",
        "phone_number": "(555) 123-4567",
        "email": "jane.doe@example.com"
      }
  }
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = AssetReportRefreshRequest(
    asset_report_token=asset_report_token,
    days_requested=90
)
response = client.asset_report_refresh(request)
asset_report_id = response['asset_report_id']
asset_report_token = response['asset_report_token']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`AssetReportUser assetReportUser = new AssetReportUser()
  .lastName("newLastName");
AssetReportRefreshRequestOptions options = new AssetReportRefreshRequestOptions()
  .user(assetReportUser);
AssetReportRefreshRequest request = new AssetReportRefreshRequest()
  .options(options)
  .assetReportToken(assetReportToken);
Response<AssetReportRefreshResponse> response = client()
  .assetReportRefresh(request)
  .execute();
String assetReportId = response.body().getAssetReportId();
String assetReportToken = response.body().getAssetReportToken();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: AssetReportRefreshRequest = {
  asset_report_token: assetReportToken,
  days_requested: 90,
  options: {
    client_report_id: '123',
    webhook: 'https://www.example.com',
    user: {
      client_user_id: '7f57eb3d2a9j6480121fx361',
      first_name: 'Jane',
      middle_name: 'Leah',
      last_name: 'Doe',
      ssn: '123-45-6789',
      phone_number: '(555) 123-4567',
      email: 'jane.doe@example.com',
    },
  },
};
try {
  const response = await plaidClient.assetReportRefresh(request);
  const assetReportId = response.data.asset_report_id;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`response, _, err := client.PlaidApi.AssetReportRefresh(ctx).AssetReportRefreshRequest(
  *plaid.NewAssetReportRefreshRequest("ASSET_REPORT_TOKEN"),
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`response, err := client.AssetReport.Refresh(ctx, &plaid.AssetReportRefreshRequest{AssetReportToken: "ASSET_REPORT_TOKEN"})
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/asset_report/refresh' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "asset_reportfilter"
    }}>{`/asset_report/filter`}</h4>
    <Schema method='POST' route='/asset_report/filter' type='request' mdxType="Schema">
      <MDXCodeBlock title='/asset_report/filter' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: AssetReportFilterRequest = {
  asset_report_token: assetReportToken,
  account_ids_to_exclude: ['JJGWd5wKDgHbw6yyzL3MsqBAvPyDlqtdyk419'],
};
try {
  const response = await plaidClient.assetReportFilter(request);
  const assetReportId = response.data.asset_report_id;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/asset_report/filter \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "asset_report_token": String,
   "account_ids_to_exclude": [String]
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`AssetReportFilterRequest request = new AssetReportFilterRequest()
  .assetReportToken(assetReportToken)
  .accountIdsToExclude(Arrays.asList("JJGWd5wKDgHbw6yyzL3MsqBAvPyDlqtdyk419"));
Response<AssetReportFilterResponse> response = client()
  .assetReportFilter(request)
  .execute();
String assetReportId = response.body().getAssetReportId();
String assetReportToken = response.body().getAssetReportToken();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::AssetReportFilterRequest.new(
  {
    asset_report_token: asset_report_token,
    account_ids_to_exclude: ["JJGWd5wKDgHbw6yyzL3MsqBAvPyDlqtdyk419"]
  }
)
response = client.asset_report_filter(request)
asset_report_id = response.asset_report_id
asset_report_token = response.asset_report_token
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`account_ids_to_exclude = ['JJGWd5wKDgHbw6yyzL3MsqBAvPyDlqtdyk419']
request = AssetReportFilterRequest(
    asset_report_token=asset_report_token,
    account_ids_to_exclude=account_ids_to_exclude
)
response = client.asset_report_filter(request)
asset_report_id = response['asset_report_id']
asset_report_token = response['asset_report_token']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`response, _, err := client.PlaidApi.AssetReportFilter(ctx).AssetReportFilterRequest(
  *plaid.NewAssetReportFilterRequest(
    "ASSET_REPORT_TOKEN",
    []string{"ACCOUNT_IDS_TO_EXCLUDE"},
  ),
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`response, err := client.AssetReport.Filter(ctx, &plaid.AssetReportFilterRequest{
    AssetReportToken:    "ASSET_REPORT_TOKEN",
    AccountIDsToExclude: []string{"ACCOUNT_IDS_TO_EXCLUDE"},
})
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/asset_report/filter' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "asset_reportremove"
    }}>{`/asset_report/remove`}</h4>
    <Schema method='POST' route='/asset_report/remove' type='request' mdxType="Schema">
      <MDXCodeBlock title='/asset_report/remove' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`response, _, err := client.PlaidApi.AssetReportRemove(ctx).AssetReportRemoveRequest(
  *plaid.NewAssetReportRemoveRequest(
    "ASSET_REPORT_TOKEN",
  ),
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`response, err := client.AssetReport.Remove(ctx, &plaid.AssetReportRemoveRequest{AssetReportToken: "ASSET_REPORT_TOKEN"})
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: AssetReportRemoveRequest = {
  asset_report_token: assetReportToken,
};
try {
  const response = await plaidClient.assetReportRemove(request);
  const removed = response.data.removed;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::AssetReportRemoveRequest.new({ asset_report_token: asset_report_token })
response = client.asset_report_remove(request)
removed = response.removed
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = AssetReportRemoveRequest(asset_report_token=asset_report_token)
response = client.asset_report_remove(request)
removed = response['removed']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`AssetReportRemoveRequest request = new AssetReportRemoveRequest()
  .assetReportToken(assetReportToken);
Response<AssetReportRemoveResponse> response = client()
  .assetReportRemove(request)
  .execute();
boolean removed = response.body().getRemoved();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/asset_report/remove \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "asset_report_token": String
 }'
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/asset_report/remove' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "asset_reportaudit_copycreate"
    }}>{`/asset_report/audit_copy/create`}</h4>
    <Schema method='POST' route='/asset_report/audit_copy/create' type='request' mdxType="Schema">
      <MDXCodeBlock title='/asset_report/audit_copy/create' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`# The auditor ID corresponds to the third party with which you want to share
# the asset report. For example, Fannie Mae's auditor ID is 'fannie_mae'.
request = AssetReportAuditCopyCreateRequest(
    asset_report_token=asset_report_token,
    auditor_id='fannie_mae'
)
response = client.asset_report_audit_copy_create(request)
audit_copy_token = response['audit_copy_token']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/asset_report/audit_copy/create \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "asset_report_token": String,
   "auditor_id": String
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`// The auditor ID corresponds to the third party with which you want to share
// the asset report. For example, Fannie Mae's auditor ID is "fannie_mae".
AssetReportAuditCopyCreateRequest request = new AssetReportAuditCopyCreateRequest()
  .assetReportToken(assetReportToken)
  .auditorId("fannie_mae");
Response<AssetReportAuditCopyCreateResponse> response =
  client().assetReportAuditCopyCreate(request).execute();
String auditCopyToken = response.body().getAuditCopyToken();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`# The auditor ID corresponds to the third party with which you want to share
# the asset report. For example, Fannie Mae's auditor ID is 'fannie_mae'.
request = Plaid::AssetReportAuditCopyCreateRequest.new(
  {
    asset_report_token: asset_report_token,
    auditor_id: 'fannie_mae'
  }
)
response = client.asset_report_audit_copy_create(request)
audit_copy_token = response.audit_copy_token
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`// The auditor ID corresponds to the third party with which you want to share
// the asset report. For example, Fannie Mae's auditor ID is 'fannie_mae'.
const request: AssetReportAuditCopyCreateRequest = {
  asset_report_token: createResponse.data.asset_report_token,
  auditor_id: 'fannie_mae',
};
try {
  const response = await plaidClient.assetReportAuditCopyCreate(request);
  const auditCopyToken = response.data.audit_copy_token;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewAssetReportAuditCopyCreateRequest("ASSET_REPORT_TOKEN")
request.SetAuditorId("AUDITOR_ID")
response, _, err := client.PlaidApi.AssetReportAuditCopyCreate(ctx).AssetReportAuditCopyCreateRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.AssetReportAuditCopyCreateRequest{AssetReportToken: "ASSET_REPORT_TOKEN"}
request.AuditorID = plaid.String("AUDITOR_ID")
response, err := client.AssetReport.CreateAuditCopy(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/asset_report/audit_copy/create' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "asset_reportaudit_copyremove"
    }}>{`/asset_report/audit_copy/remove`}</h4>
    <Schema method='POST' route='/asset_report/audit_copy/remove' type='request' mdxType="Schema">
      <MDXCodeBlock title='/asset_report/audit_copy/remove' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/asset_report/audit_copy/remove \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "audit_copy_token": String
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`# audit_copy_token is the token from the AssetReport.audit_copy.create response.
request = AssetReportAuditCopyRemoveRequest(
    audit_copy_token=audit_copy_token,
)
response = client.asset_report_audit_copy_remove(request)
removed = response['removed']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`// auditCopyToken is the token from the createAuditCopy response.
const request: AssetReportAuditCopyRemoveRequest = {
  audit_copy_token: auditCopyToken,
};
try {
  const response = await plaidClient.assetReportAuditCopyRemove(request);
  const removed = response.data.removed;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`# audit_copy_token is the token from the create_audit_copy response.
request = Plaid::AssetReportAuditCopyRemoveRequest.new({ audit_copy_token: audit_copy_token })
response = client.asset_report_audit_copy_remove(request)
removed = response.removed
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`// auditCopyToken is the token from the assetReportAuditCopyCreate response.
AssetReportAuditCopyRemoveRequest request = new AssetReportAuditCopyRemoveRequest()
  .auditCopyToken(auditCopyToken);
Response<AssetReportAuditCopyRemoveResponse> response = client()
  .assetReportAuditCopyRemove(request)
  .execute();
boolean removed = response.body().getRemoved();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`response, _, err := client.PlaidApi.AssetReportAuditCopyRemove(ctx).AssetReportAuditCopyRemoveRequest(
  *plaid.NewAssetReportAuditCopyRemoveRequest(
    "AUDIT_COPY_TOKEN",
  ),
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`response, err := client.AssetReport.RemoveAuditCopy(ctx, &plaid.AssetReportAuditCopyRemoveRequest{AuditCopyToken: "AUDIT_COPY_TOKEN"})
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/asset_report/audit_copy/remove' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "creditrelaycreate"
    }}>{`/credit/relay/create`}</h4>
    <Schema method='POST' route='/credit/relay/create' type='request' mdxType="Schema">
      <MDXCodeBlock title='/credit/relay/create' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CreditRelayCreateRequest(
    report_tokens=[asset_report_token],
    secondary_client_id=client_id_from_partner,
)
response = client.credit_relay_create(request)
relay_token = response['relay_token']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/credit/relay/create \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "secondary_client_id": "\${SECONDARY_CLIENT_ID}",
   "report_tokens": ["\${ASSET_REPORT_TOKEN}"]
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CreditRelayCreateRequest request = new CreditRelayCreateRequest()
  .reportTokens(Arrays.asList(assetReportToken))
  .secondaryClientId(clientIdFromPartner);
Response<CreditRelayCreateResponse> response =
  client().creditRelayCreate(request).execute();
String relayToken = response.body().getRelayToken();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CreditRelayCreateRequest.new(
  {
    report_tokens: [asset_report_token],
    secondary_client_id: clientIdFromPartner
  }
)
response = client.credit_relay_create(request)
relay_token = response.relay_token
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: CreditRelayCreateRequest = {
  report_tokens: [createResponse.data.asset_report_token],
  secondary_client_id: clientIdFromPartner
};
try {
  const response = await plaidClient.creditRelayCreate(request);
  const relayToken = response.data.relay_token;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`response, _, err := client.PlaidApi.CreditRelayCreate(ctx).CreditRelayCreateRequest(
  *plaid.NewCreditRelayCreateRequest(
    []string{"ASSET_REPORT_TOKEN"},
    clientIdFromPartner,
  ),
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`response, err := client.Credit.CreateRelay(ctx, &plaid.CreditRelayCreateRequest{
    ReportTokens:      []string{"ASSET_REPORT_TOKEN"},
    SecondaryClientID: clientIdFromPartner,
})
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/credit/relay/create' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "creditrelayget"
    }}>{`/credit/relay/get`}</h4>
    <Schema method='POST' route='/credit/relay/get' type='request' mdxType="Schema">
      <MDXCodeBlock title='/credit/relay/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CreditRelayGetRequest(
    relay_token=relay_token,
    report_type=ReportType('asset')
)
response = client.credit_relay_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/credit/relay/get \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "relay_token": String,
   "report_type": String,
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CreditRelayGetRequest request = new CreditRelayGetRequest()
  .relayToken(relayToken)
  .reportType(ReportType.ASSET);
Response<AssetReportGetResponse> response =
  client().creditRelayGet(request).execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CreditRelayGetRequest.new(
  {
    relay_token: relay_token,
    report_type: 'asset'
  }
)
response = client.credit_relay_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: CreditRelayGetRequest = {
  relay_token: createResponse.data.relay_token,
  report_type: 'asset',
};
try {
  const response = await plaidClient.creditRelayGet(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`response, _, err := client.PlaidApi.CreditRelayGet(ctx).CreditRelayGetRequest(
  *plaid.NewCreditRelayGetRequest(
    "relay_token",
    "asset",
  ),
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`response, err := client.Credit.GetRelay(ctx, &plaid.CreditRelayGetRequest{
    RelayToken: "relay_token",
    ReportType: "asset",
})
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/credit/relay/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "creditrelayrefresh"
    }}>{`/credit/relay/refresh`}</h4>
    <Schema method='POST' route='/credit/relay/refresh' type='request' mdxType="Schema">
      <MDXCodeBlock title='/credit/relay/refresh' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CreditRelayRefreshRequest(
    relay_token=relay_token,
    report_type=ReportType('asset')
)
response = client.credit_relay_refresh(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/credit/relay/refresh \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "relay_token": String,
   "report_type": String,
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CreditRelayRefreshRequest request = new CreditRelayRefreshRequest()
  .relayToken(relayToken)
  .reportType(ReportType.ASSET);
Response<CreditRelayRefreshResponse> response =
  client().creditRelayRefresh(request).execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CreditRelayRefreshRequest.new(
  {
    relay_token: relay_token,
    report_type: 'asset'
  }
)
response = client.credit_relay_refresh(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: CreditRelayRefreshRequest = {
  relay_token: createResponse.data.relay_token,
  report_type: 'asset',
};
try {
  const response = await plaidClient.creditRelayRefresh(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`response, _, err := client.PlaidApi.CreditRelayRefresh(ctx).CreditRelayRefreshRequest(
  *plaid.NewCreditRelayRefreshRequest(
    "relay_token",
    "asset",
  ),
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`response, err := client.Credit.RefreshRelay(ctx, &plaid.CreditRelayRefreshRequest{
    RelayToken: "relay_token",
    ReportType: "asset",
})
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/credit/relay/refresh' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "creditrelayremove"
    }}>{`/credit/relay/remove`}</h4>
    <Schema method='POST' route='/credit/relay/remove' type='request' mdxType="Schema">
      <MDXCodeBlock title='/credit/relay/remove' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CreditRelayRemoveRequest(
    relay_token=relay_token
)
response = client.credit_relay_remove(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/credit/relay/remove \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "relay_token": String,
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CreditRelayRemoveRequest request = new CreditRelayRemoveRequest()
  .relayToken(relayToken);
Response<CreditRelayRemoveResponse> response =
  client().creditRelayRemove(request).execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CreditRelayRemoveRequest.new(
  {
    relay_token: relay_token
  }
)
response = client.credit_relay_remove(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: CreditRelayRemoveRequest = {
  relay_token: createResponse.data.relay_token,
};
try {
  const response = await plaidClient.creditRelayRemove(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`response, _, err := client.PlaidApi.CreditRelayRemove(ctx).CreditRelayRemoveRequest(
  *plaid.NewCreditRelayRemoveRequest(
    "relay_token",
  ),
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`response, err := client.Credit.RemoveRelay(ctx, &plaid.CreditRelayRemoveRequest{RelayToken: "relay_token"})
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/credit/relay/remove' type='response' mdxType="Schema" />
    <h3 {...{
      "id": "webhooks"
    }}>{`Webhooks`}</h3>
    <h4 {...{
      "id": "product_ready"
    }}><inlineCode parentName="h4">{`PRODUCT_READY`}</inlineCode></h4>
    <Schema model='AssetsProductReadyWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "error"
    }}><inlineCode parentName="h4">{`ERROR`}</inlineCode></h4>
    <Schema model='AssetsErrorWebhook' type='model' mdxType="Schema" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "endpoints",
        level: 3,
        title: "Endpoints",
      },
{
        id: "asset_reportcreate",
        level: 4,
        title: "/asset_report/create",
      },
{
        id: "asset_reportget",
        level: 4,
        title: "/asset_report/get",
      },
{
        id: "asset_reportpdfget",
        level: 4,
        title: "/asset_report/pdf/get",
      },
{
        id: "asset_reportrefresh",
        level: 4,
        title: "/asset_report/refresh",
      },
{
        id: "asset_reportfilter",
        level: 4,
        title: "/asset_report/filter",
      },
{
        id: "asset_reportremove",
        level: 4,
        title: "/asset_report/remove",
      },
{
        id: "asset_reportaudit_copycreate",
        level: 4,
        title: "/asset_report/audit_copy/create",
      },
{
        id: "asset_reportaudit_copyremove",
        level: 4,
        title: "/asset_report/audit_copy/remove",
      },
{
        id: "creditrelaycreate",
        level: 4,
        title: "/credit/relay/create",
      },
{
        id: "creditrelayget",
        level: 4,
        title: "/credit/relay/get",
      },
{
        id: "creditrelayrefresh",
        level: 4,
        title: "/credit/relay/refresh",
      },
{
        id: "creditrelayremove",
        level: 4,
        title: "/credit/relay/remove",
      },
{
        id: "webhooks",
        level: 3,
        title: "Webhooks",
      },
{
        id: "product_ready",
        level: 4,
        title: "PRODUCT_READY",
      },
{
        id: "error",
        level: 4,
        title: "ERROR",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
